import {Lens} from '@dhmk/zustand-lens'

// "pk" must exist in target Type

type ChatState = {
    needReInitAfterNotification: boolean
    needReInitAfterChangedRepresentedHost: boolean
}

type ChannelActions = {
    setNeedReInitAfterNotification: (neededReInit: boolean) => void
    reset: () => void
    setNeedReInitAfterChangedRepresentedHost: (neededReInit: boolean) => void
}

type ChatActions = ChannelActions
export type ChatSlice = ChatState & ChatActions

const initialState: ChatState = {
    needReInitAfterNotification: false,
    needReInitAfterChangedRepresentedHost: false
}

const createChatSlice: Lens<ChatSlice> = set => ({
    ...initialState,

    setNeedReInitAfterNotification: (neededReInit: boolean) =>
        set(state => ({
            ...state,
            needReInitAfterNotification: neededReInit
        })),
    setNeedReInitAfterChangedRepresentedHost: (neededReInit: boolean) =>
        set(state => ({
            ...state,
            needReInitAfterChangedRepresentedHost: neededReInit
        })),
    reset: () => {
        set(initialState)
    }
})

export default createChatSlice
